export const actions = {
  SetAlertMessage({ commit, state }, input) {
    setTimeout(() => {
      commit("MutationSetAlertMessage", input);
    }, 50);
  },
  ResetAlertMessage({ commit, state }) {
    setTimeout(() => {
      commit("MutationResetAlertMessage");
    }, 50);
  },
};
